import { bindServices } from '@/services/api';

const api = bindServices('subSequence');
import { getById } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { merge } from 'lodash';

const { ManageSubSequence } = CoreQueries;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'subSequence',

  state: {
    list: [],
    orderBy: '',
    pagination: { ...meta },
    searchTable: '',
    selectedItem: {},
    openCreateOrEdit: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const params = { route: 'sequenceItem', ...payload, ...ManageSubSequence.paged };
        const response = yield call(api.getPerPaged, params);
        yield put({
          type: 'queryList',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            searchTable: payload.search,
          },
        });
      } catch (error) {}
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *deleteItem({ id, params }, { call, put }) {
      try {
        const paramsRemove = { route: 'sequenceItem', id };
        const response = yield call(api.remove, paramsRemove);
        yield put({
          type: 'queryDeleteItem',
          payload: response,
        });

        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsForm`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
    *toggleCreateOrEditDrawer({ payload: { id, state, item } }, { put }) {
      yield put({
        type: 'queryToggleCreateOrEditDrawer',
        payload: {
          id,
          state,
          item,
        },
      });
    },
    *saveItem({ payload }, { call, put }) {
      try {
        const params = { route: 'sequenceItem', data: payload.data };
        if (payload.data.id) {
          yield call(api.update, params);
        } else {
          yield call(api.create, params);
        }
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
        yield put({
          type: 'toggleCreateOrEditDrawer',
          payload: {
            id: null,
            state: false,
            item: null,
          },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotificationsForm`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: true,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *getItem({ payload }, { call, put }) {
      try {
        const paramsGet = {
          route: 'sequenceItem',
          id: payload.id,
          params: { ...ManageSubSequence.edit },
        };
        const response = yield call(getById, paramsGet);
        yield put({
          type: 'queryGetItem',
          payload: {
            id: payload.id,
            item: response,
          },
        });
      } catch (error) {}
    },
  },

  reducers: {
    queryList(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: merge(state.pagination, toPaginate(payload)),
        searchTable: payload.searchTable ? payload.searchTable : '',
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        orderBy: '',
      };
    },
    queryToggleCreateOrEditDrawer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openCreateOrEdit: payload.state,
        selectedItem: payload.item,
      };
    },
    queryGetItem(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
      };
    },
    setPatternInSelectedItem(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.itemValues,
      };
    },
  },
};

export default Model;
